import React, { useRef } from "react";
import { Link } from "react-router-dom";
// import "../CustomListingCard/CustomListingCard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import styles from "./NewAgentSearchPage.module.scss";
import { formatIndianCurrency } from "../../../utils/utils";

function NewAgentActivityCard({
  imgSrc,
  id,
  title,
  packagehandle,
  duration,
  nightDuration,
  packageHub,
  price,
  bookingLink,
  detailsLink,
  packageHotels,
  canBookable,
  description,
  slug,
  setShowSendEnquiryPopup,
  markupData,
  sendEnquiry,
  activityDestination,
}) {
  const navigate = useNavigate();
  const [data, setData] = useState({ fromCity: "", toCity: "" });
  const [departureDate, setdepartureDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState(new Date());
  const [hotelData, setHotelData] = useState([]);
  const [guest, setGuest] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);
  const [bookingData, setBookingData] = useState({});
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      date: params.get("date"),
      year: params.get("year"),
      month: params.get("month"),
      radio: params.get("radio"),
      childAge: childAges,
    };

    const checkInDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
      // toCity: params.get("location"),
    });

    setGuest(data.guest ? data.guest : 2);
    setChildren(data?.children ? data?.children : 0);
    setRooms(data.room);
    setChildAge(childAges);
    setdepartureDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData(data);
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    // Default to current date, month, and year if not in params
    const currentDate = new Date();
    const data = {
      hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      date: params.get("date") || currentDate.getDate(),
      month: params.get("month") || currentDate.getMonth() + 1, // Months are 0-indexed
      year: params.get("year") || currentDate.getFullYear(),
      radio: params.get("radio"),
      childAge: childAges,
    };

    // Construct check-in and check-out dates
    const checkInDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
      // toCity: params.get("location"),
    });

    setGuest(data.guest ? data.guest : 2);
    setChildren(data?.children ? data?.children : 0);
    setRooms(data.room);
    setChildAge(childAges);
    setdepartureDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData(data);
  }, [location.search]);

  const handleSelectRoomClickHandler = async (item, hotelData, room_id) => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    // console.log(children, 'jjj');

    // Calculate booking values before navigating
    try {
      await navigate(
        `/single-activity-search/${slug}?${id}?location=${
          data.fromCity ? data.fromCity : ""
        }&adult=${guest}&date=${bookingData.date}&month=${
          bookingData.month
        }&year=${bookingData.year}`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [showRatePopup, setshowRatePopup] = useState(false);
  const handleshowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(!showRatePopup);
  };
  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // console.log(showRatePopup);

  const calculatePriceWithMarkup = (basePrice) => {
    if (!markupData) return basePrice;

    const { markupType, amount } = markupData;

    if (markupType === "percentage") {
      const percentageAmount = (parseFloat(amount) / 100) * basePrice;
      return basePrice + percentageAmount;
    }

    if (markupType === "fixed") {
      return basePrice + parseFloat(amount);
    }

    return basePrice;
  };

  const finalPrice = calculatePriceWithMarkup(price);

  const titleRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (titleRef.current) {
      setIsTruncated(
        titleRef.current.scrollWidth > titleRef.current.clientWidth
      );
    }
  }, [title]);
  return (
    <>
      <div className={styles.NewUIActivityPageCardMountain}>
        <div className={styles.listing_card_data}>
          <div className={styles.img_sec}>
            <img
              onClick={() => {
                handleSelectRoomClickHandler();
                scroll.scrollToTop({ duration: 500, smooth: "easeInOutQuad" });
              }}
              src={imgSrc}
              alt={title}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className={styles.detail_button_align}>
            <div className={styles.content_sec}>
              <div>
                {" "}
                <div className={styles.location}>
                  <div>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_5983_7301"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="18"
                        height="18"
                      >
                        <rect width="18" height="18" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5983_7301)">
                        <path
                          d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                    {activityDestination}
                  </div>
                </div>
                <div className={styles.titleContainer}>
                  <h3
                    style={{ padding: "0" }}
                    ref={titleRef}
                    className={styles.truncatedTitle}
                    onClick={() => {
                      handleSelectRoomClickHandler();
                      scroll.scrollToTop({
                        duration: 500,
                        smooth: "easeInOutQuad",
                      });
                    }}
                  >
                    {title}
                  </h3>
                  {isTruncated && (
                    <span className={styles.fullTitle}>{title}</span>
                  )}
                </div>
              </div>
              <div className={styles.price_info}>
                <h4>{formatIndianCurrency(finalPrice)}</h4>
                <small>Per Person</small>
              </div>
            </div>
            <div className={styles.btns}>
              <button
                className={styles.view_btn}
                onClick={() => {
                  handleSelectRoomClickHandler();
                  scroll.scrollToTop({
                    duration: 500,
                    smooth: "easeInOutQuad",
                  });
                }}
              >
                View Details
              </button>
              <button className={styles.request_btn} onClick={sendEnquiry}>
                request callback
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewAgentActivityCard;
